module.exports = __webpack_public_path__ + "static/billsby-payment-gateways-51d91d78def3086a17b8f47410aeb56e.svg";